import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./Login";
import Dashboard from "./Dashboard";

function App() {
  const isValidToken = (t) => t && t.length > 10; // simple check
  const [token, setToken] = useState(() => {
    const t = localStorage.getItem("token");
    return isValidToken(t) ? t : null;
  });

  const handleLogin = () => {
    const stored = localStorage.getItem("token");
    setToken(isValidToken(stored) ? stored : null);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    setToken(null);
  };

  return (
    <Routes>
      <Route
        path="/login"
        element={
          token ? <Navigate to="/dashboard" /> : <Login onLoginSuccess={handleLogin} />
        }
      />
      <Route
        path="/dashboard"
        element={
          token ? <Dashboard onLogout={handleLogout} /> : <Navigate to="/login" />
        }
      />
      <Route
        path="*"
        element={<Navigate to={token ? "/dashboard" : "/login"} />}
      />
    </Routes>
  );
}

export default App;
